import { Component, Host, h, Prop } from "@stencil/core";

import { getImages } from "./get-images";
import { fixIEShadowDom } from "../../../utils/fix-ie-shadow-dom";
import { hideFromScreenReader } from "../../../utils/hide-from-screen-reader";

@Component({
    tag: "leichte-sprache-bubble-two-column-images",
    styleUrl: "leichte-sprache-bubble-two-column-images.scss",
})
export class LeichteSpracheBubbleTwoColumnImages {
    @Prop() text: string;
    @Prop() url: string;

    render() {
        return (
            <Host>
                <section>
                    <div
                        class="left"
                        innerHTML={hideFromScreenReader(
                            fixIEShadowDom(
                                this.text,
                                "leichte-sprache-bubble-two-column-images"
                            ),
                            // br needs to be hidden, otherwise VoiceOver reads every element twice and says "group" for each line
                            ["img", "br"]
                        )}
                    ></div>
                    <div
                        class="right"
                        innerHTML={hideFromScreenReader(
                            fixIEShadowDom(
                                getImages(this.url),
                                "leichte-sprache-bubble-two-column-images"
                            ),
                            ["img"]
                        )}
                    ></div>
                </section>
            </Host>
        );
    }
}
